import React, { useState, useEffect, useRef } from "react"
import TrustpilotReviews from "@pittica/gatsby-plugin-trustpilot-widget"

const TrustPilotWidget = (props) =>{
    return (
        <div className="trustpilot-reviews-list-widget">
            <TrustpilotReviews
            language="en"
            culture="US"
            theme="dark"
            width="100%"
            height="52px"
            template="5419b6ffb0d04a076446a9af"
            business="556c78ad0000ff00057fd7be"
            username="www.cubittandwest.co.uk"
            />
        </div>
    )
}

export default TrustPilotWidget;
